import {
  REQUEST_LINK_USER,
  RECEIVE_LINK_USER,
  FAIL_LINK_USER
} from '../actions';

const defaultState = {
  auth: null,
  isRequestingUser: false,
  err: null,
  nextPage: null,
  createConfirm: null
};

const linkReducer = (state = defaultState, action) => {
  switch (action.type) {
    case REQUEST_LINK_USER:
      return {
        ...state,
        isRequestingUser: action.isRequestingUser,
        auth: null,
        err: null
      };
    case RECEIVE_LINK_USER:
      return {
        ...state,
        auth: action.json,
        isRequestingUser: false,
        err: null,
        nextPage: '/register/sso-confirm/',
        createConfirm: false
      };
    case FAIL_LINK_USER:
      return {
        ...state,
        err: action.error,
        isRequestingUser: false,
        auth: null
      };
    default:
      return state;
  }
};

export default linkReducer;
